import React, { useState } from "react";
import UserProfile from "../../Components/Profile/UserProfile";
import ChangePassword from "../../Components/Profile/ChangePassword";
import EditProfile from "../../Components/Profile/EditProfile";
import MyBlogs from "../../Components/Profile/MyBlogs";
import Followers from "../../Components/Profile/Followers";
import Following from "../../Components/Profile/Following";

const Profile = () => {
  const tabsData = [
    {
      label: "Profile",
      content: <UserProfile />,
    },
    {
      label: "Edit Profile",
      content: <EditProfile />,
    },
    {
      label: "Change Password",
      content: <ChangePassword />,
    },

    {
      label: "Your Blogs",
      content: <MyBlogs />,
    },
    {
      label: "Followings",
      content: <Followers />,
    },
    {
      label: "Followers",
      content: <Following />,
    },
  ];

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  return (
    <>
      <div className="flex pl-4 pt-4 bg-green-600 space-x-3 border-b">
        {tabsData.map((tab, idx) => {
          return (
            <button
              key={idx}
              className={`py-2 border-b-4 p-5 text-white transition-colors duration-300 ${
                idx === activeTabIndex
                  ? "border-gray-900"
                  : "border-transparent hover:border-white hover:text-gray-800"
              }`}
              onClick={() => setActiveTabIndex(idx)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      <div className="py-4 px-4">
        <div>{tabsData[activeTabIndex].content}</div>
      </div>
    </>
  );
};

export default Profile;
